import { SchoolAddress, SchoolAddressMagentoResponse } from "../../instructor-sample/instructor-sample.interface";

export function mapSchoolAddressMagento(schoolAddressMagento: SchoolAddressMagentoResponse): SchoolAddress[] {
    const schoolAddressItems = schoolAddressMagento.items;
    return schoolAddressItems.map(schoolAddressItem => ({
      userId: schoolAddressItem.userId,
      schoolId: schoolAddressItem.schoolId,
      deptId: schoolAddressItem?.deptId || null,
      id: 0,
      isPrimary: schoolAddressItem.isPrimary,
      sfdcAddressId: schoolAddressItem.sfdcAddressId,
      lineOne: schoolAddressItem.lineOne,
      lineTwo: schoolAddressItem?.lineTwo || null,
      city: schoolAddressItem.city,
      state: schoolAddressItem.state,
      country: schoolAddressItem.country,
      zipCode: schoolAddressItem.zipCode,
      schoolName: schoolAddressItem?.schoolName || null,
      type: null,
      primary: null
    }));  
}
